<template>
  <div>
    <div class="page-header clear-filter" filter-color="">
      <parallax
        class="page-header-image"
        style="background-image: url('img/facility/DSC_3387.jpg')"
      >
      </parallax>
      <div class="container">
        <h2 class="title mt-5">{{ $t('factoryTour.hero.title') }}</h2>
        <h5 class="text-white">{{ $t('factoryTour.hero.subtitle') }}</h5>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <h3 class="font-weight-bold" style="color: #008c45;">{{ $t('factoryTour.intro.heading') }}</h3>
        <h5 class="text-dark">{{ $t('factoryTour.intro.description') }}</h5>

        <div class="row mt-5 align-items-stretch">
          <div class="col-lg-3 col-6 mb-4 d-flex">
            <div class="tour-highlight-card w-100">
              <div class="tour-highlight-icon"><i class="fa fa-calendar-alt"></i></div>
              <h6 class="font-weight-bold mt-3">{{ $t('factoryTour.highlights.schedule.title') }}</h6>
              <p>{{ $t('factoryTour.highlights.schedule.desc') }}</p>
            </div>
          </div>
          <div class="col-lg-3 col-6 mb-4 d-flex">
            <div class="tour-highlight-card w-100">
              <div class="tour-highlight-icon"><i class="fa fa-clock"></i></div>
              <h6 class="font-weight-bold mt-3">{{ $t('factoryTour.highlights.advanceBooking.title') }}</h6>
              <p>{{ $t('factoryTour.highlights.advanceBooking.desc') }}</p>
            </div>
          </div>
          <div class="col-lg-3 col-6 mb-4 d-flex">
            <div class="tour-highlight-card w-100">
              <div class="tour-highlight-icon"><i class="fa fa-users"></i></div>
              <h6 class="font-weight-bold mt-3">{{ $t('factoryTour.highlights.groupSize.title') }}</h6>
              <p>{{ $t('factoryTour.highlights.groupSize.desc') }}</p>
            </div>
          </div>
          <div class="col-lg-3 col-6 mb-4 d-flex">
            <div class="tour-highlight-card w-100">
              <div class="tour-highlight-icon"><i class="fa fa-shield-alt"></i></div>
              <h6 class="font-weight-bold mt-3">{{ $t('factoryTour.highlights.freeOfCharge.title') }}</h6>
              <p>{{ $t('factoryTour.highlights.freeOfCharge.desc') }}</p>
            </div>
          </div>
        </div>

        <div class="card-custom card-body mt-4 text-dark">
          <h4 class="font-weight-bold">{{ $t('factoryTour.terms.heading') }}</h4>
          <ul class="mb-0">
            <li v-for="(item, i) in $t('factoryTour.terms.items')" :key="i" class="mb-2">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="section" style="background-color: #f7f9f8;">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <h2 class="font-weight-bold align-middle mb-2">
              <span style="color: #008c45;">{{ $t('factoryTour.form.heading') }}</span>
            </h2>
            <h6 class="text-black text-left font-weight-bold mb-4">
              {{ $t('factoryTour.form.subheading') }}
            </h6>

            <label class="mt-3">{{ $t('factoryTour.form.fullName') }} <span style="color: red">*</span></label><br />
            <fg-input
              class="has-success input-lg mb-1"
              :placeholder="$t('factoryTour.form.fullName')"
              required
              v-model="tourData.fullName"
            >
            </fg-input>

            <label class="mt-3">{{ $t('factoryTour.form.institutionName') }} <span style="color: red">*</span></label><br />
            <fg-input
              class="has-success input-lg mb-1"
              :placeholder="$t('factoryTour.form.institutionName')"
              required
              v-model="tourData.institutionName"
            >
            </fg-input>

            <label class="mt-3">{{ $t('factoryTour.form.email') }} <span style="color: red">*</span></label><br />
            <fg-input
              class="has-success input-lg mb-1"
              :placeholder="$t('factoryTour.form.email')"
              required
              type="email"
              v-model="tourData.email"
            >
            </fg-input>

            <label class="mt-3">{{ $t('factoryTour.form.phoneNumber') }} <span style="color: red">*</span></label><br />
            <fg-input
              class="has-success input-lg mb-1"
              :placeholder="$t('factoryTour.form.phoneNumber')"
              required
              v-model="tourData.phoneNumber"
            >
            </fg-input>

            <div class="row">
              <div class="col-md-6">
                <label class="mt-3">{{ $t('factoryTour.form.participants') }} <span style="color: red">*</span></label><br />
                <fg-input
                  class="has-success input-lg mb-1"
                  :placeholder="$t('factoryTour.form.participants')"
                  required
                  type="number"
                  min="1"
                  v-model="tourData.participants"
                >
                </fg-input>
              </div>
              <div class="col-md-6">
                <label class="mt-3">{{ $t('factoryTour.form.preferredDate') }} <span style="color: red">*</span></label><br />
                <fg-input
                  class="has-success input-lg mb-1"
                  required
                  type="date"
                  v-model="tourData.preferredDate"
                >
                </fg-input>
              </div>
            </div>

            <label class="mt-3">{{ $t('factoryTour.form.purpose') }}</label><br />
            <textarea
              style="
                border-radius: 10px;
                border: 1px solid #dcdcdc;
                color: #808080;
                font-size: 12px;
                width: 100%;
              "
              rows="5"
              :placeholder="$t('factoryTour.form.purposePlaceholder')"
              v-model="tourData.purpose"
            >
            </textarea>

            <p class="mt-3"><small class="text-muted">{{ $t('factoryTour.form.requiredNotice') }}</small></p>

            <n-button
              type="success"
              size="lg"
              class="float-right mr-0 font-weight-bold"
              @click="save()"
              :disabled="onLoading"
            >
              <span v-if="onLoading"
                ><i class="fa fa-spinner fa-spin"></i> {{ $t('factoryTour.form.pleaseWait') }}</span
              >
              <span v-else>
                <i class="fa fa-paper-plane mr-3" aria-hidden="true"></i
                ><span>{{ $t('factoryTour.form.submit') }}</span>
              </span>
            </n-button>
          </div>
          <div class="col-lg-6 d-none d-lg-block">
            <img
              src="img/facility/crane.jpg"
              :alt="$t('factoryTour.hero.title')"
              class="img-fluid rounded"
              style="margin-top: 40px;"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FormGroupInput, Button } from '@/components';
import Api from '@/helpers/api';
import factoryTour from '@/services/factoryTour.service';

export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    [FormGroupInput.name]: FormGroupInput,
    [Button.name]: Button,
  },
  data() {
    return {
      onLoading: false,
      tourData: {},
    };
  },
  methods: {
    save() {
      let context = this;
      let formData = new FormData();
      this.onLoading = true;

      if (
        this.tourData.fullName != undefined &&
        this.tourData.institutionName != undefined &&
        this.tourData.email != undefined &&
        this.tourData.phoneNumber != undefined &&
        this.tourData.participants != undefined &&
        this.tourData.preferredDate != undefined
      ) {
        formData.append('full_name', this.tourData.fullName);
        formData.append('institution_name', this.tourData.institutionName);
        formData.append('email', this.tourData.email);
        formData.append('phone_number', this.tourData.phoneNumber);
        formData.append('participants', this.tourData.participants);
        formData.append('preferred_date', this.tourData.preferredDate);
        formData.append('purpose', this.tourData.purpose || '');
      } else {
        context.onLoading = false;
        return alert(context.$t('factoryTour.form.requiredNotice'));
      }

      Api(context, factoryTour.register(formData))
        .onSuccess(function () {
          context.$notify(context.$t('factoryTour.form.successMessage'), 'success');
          context.tourData = {};
        })
        .onError(function (error) {
          let errorMsg = context.$t('factoryTour.form.errorMessage');
          const data = error.response && error.response.data;
          if (data) {
            if (data.errors) {
              const messages = Object.values(data.errors).flat();
              if (messages.length) {
                errorMsg = messages.join(' ');
              }
            } else if (data.message) {
              errorMsg = data.message;
            }
          }
          context.$notify(errorMsg, 'error');
        })
        .onFinish(function () {
          context.onLoading = false;
        })
        .call();
    },
  },
};
</script>
<style scoped>
.card-custom {
  background-color: #008c45;
  color: white;
  border-radius: 25px;
  padding: 20px;
}

.card-custom h4,
.card-custom ul,
.card-custom ul li {
  color: #fff;
}

.tour-highlight-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px 20px;
  text-align: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.tour-highlight-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.15);
}

.tour-highlight-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #e6f4ec;
  color: #008c45;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.tour-highlight-card p {
  color: #6c757d;
  font-size: 14px;
  margin-top: 8px;
  margin-bottom: 0;
}
</style>
